import { render, staticRenderFns } from "./TempStarsTableTitle.vue?vue&type=template&id=0dd4c4ce"
import script from "./TempStarsTableTitle.vue?vue&type=script&lang=ts"
export * from "./TempStarsTableTitle.vue?vue&type=script&lang=ts"
import style0 from "./TempStarsTableTitle.vue?vue&type=style&index=0&id=0dd4c4ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports